"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const moment_1 = __importDefault(require("moment"));
const Layers_1 = __importDefault(require("@mui/icons-material/Layers"));
const shared_1 = require("../shared");
const PaymentSubscriptions = ({ open, onClose, subscription, subscribed, handleSnackBarOpen = () => { }, handleSnackBarClose = () => { } }) => {
    var _a, _b;
    const transactionId = subscribed === null || subscribed === void 0 ? void 0 : subscribed.transactionId;
    const [sendToAlternative, setSendToAlternative] = (0, react_1.useState)(false);
    const [countryData, setCountryData] = react_1.default.useState([]);
    const [expMonths, setExpMonths] = react_1.default.useState([]);
    const [expYears, setExpYears] = react_1.default.useState([]);
    const [alertOpen, setAlertOpen] = react_1.default.useState(false);
    const [ConfirmDialogOpen, setConfirmDialogOpen] = react_1.default.useState(false);
    const handleClickOpen = () => {
        setConfirmDialogOpen(true);
    };
    const handleClose = () => {
        setConfirmDialogOpen(false);
    };
    const getCardDetails = async (transactionId) => {
        if (!transactionId) {
            console.log('No transaction ID available');
            return;
        }
        try {
            const response = await (0, shared_1.callApi)(`payment/${transactionId}`, 'GET');
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            console.log('response:', data);
            setPaymentDetails(data);
            console.log('creditencrypted', data.creditCardNum);
        }
        catch (error) {
            console.log('Error:', error);
        }
    };
    const setPaymentDetails = (user) => {
        console.log('user', user);
        setpaymentData(Object.assign(Object.assign({}, paymentData), { data: Object.assign(Object.assign({}, paymentData.data), { userID: user.userId, amount: user.amount, transactionDate: user.transactionDate, courseId: user.courseId, creditCardType: user.creditCardType, nameOnAccount: user.nameOnAccount, address: user.address, city: user.city, state: user.state, postCode: user.postCode, country: user.country, creditCardNum: user.creditCardNum, expirationMonth: '', expirationYear: '' }) }));
    };
    const [paymentData, setpaymentData] = react_1.default.useState({
        data: {
            creditCardNum: '',
            cvv: '',
            expirationMonth: '',
            expirationYear: '',
            nameOnAccount: '',
            address: '',
            city: '',
            state: '',
            postCode: '',
            country: '',
            userID: '',
            transactionDate: '',
            creditCardType: '',
            courseId: '',
            amount: ''
        },
        error: {
            // creditCardType: false,
            amount: false,
            creditCardNum: false,
            cvv: false,
            expirationMonth: false,
            expirationYear: false,
            nameOnAccount: false,
            address: false,
            city: false,
            state: false,
            postCode: false,
            country: false,
        },
        errorMessage: {
            required: '',
            creditCardNum: '',
            cvv: '',
            expirationMonth: '',
        },
    });
    const userId = paymentData.data.userID;
    const fetchCountryData = async () => {
        try {
            const response = await fetch(`https://restcountries.com/v3.1/all?fields=name,flags,cca3,idd,common`);
            const data = await response.json();
            const options = data.map((country) => {
                let root_idd = country.idd.root ? country.idd.root : '';
                let suffix_idd = country.idd.suffixes && country.idd.suffixes.length > 0 ? country.idd.suffixes[0] : '';
                return {
                    label: country.name.common,
                    id: country.cca3,
                    flag: country.flags[0],
                    phCode: root_idd.concat('', suffix_idd),
                };
            });
            setCountryData(options);
        }
        catch (error) {
            console.warn('Fetch Error: ', error);
        }
    };
    const setExpMonthAndYear = () => {
        const expMonthList = moment_1.default.months();
        const currentYear = new Date().getFullYear();
        const expYearList = Array.from({ length: 12 }, (_, index) => currentYear + index);
        let months = [];
        let years = [];
        expMonthList.forEach((month, idx) => {
            let id = String(idx + 1).padStart(2, '0');
            months.push({ id: id, name: month });
        });
        expYearList.forEach((year, idx) => {
            let id = year % 100;
            years.push({ id: id, name: year });
        });
        setExpMonths(months);
        setExpYears(years);
    };
    const isEmptyOrSpaces = (value) => {
        return value === undefined || value === null || value === '';
    };
    const validateAll = () => {
        let isValidData = true;
        let amount = false;
        let creditCardNum = false;
        let cvv = false;
        let expirationMonth = false;
        let expirationYear = false;
        let nameOnAccount = false;
        let country = false;
        let address = false;
        let city = false;
        let state = false;
        let postCode = false;
        const errorMessage = Object.assign(Object.assign({}, paymentData.errorMessage), { required: 'This field is required' });
        if (isEmptyOrSpaces(paymentData.data.nameOnAccount)) {
            nameOnAccount = true;
            errorMessage.nameOnAccount = 'This field is required';
        }
        if (isEmptyOrSpaces(paymentData.data.creditCardNum)) {
            creditCardNum = true;
            errorMessage.creditCardNum = 'This field is required';
        }
        else if (!/^\d{10,20}$/.test(paymentData.data.creditCardNum)) {
            creditCardNum = true;
            errorMessage.creditCardNum = 'Invalid credit card number';
        }
        if (isEmptyOrSpaces(paymentData.data.cvv)) {
            cvv = true;
            errorMessage.cvv = 'This field is required';
        }
        else if (!/^\d{3,4}$/.test(paymentData.data.cvv)) {
            cvv = true;
            errorMessage.cvv = 'Invalid CVV code.';
        }
        if (isEmptyOrSpaces(paymentData.data.expirationMonth)) {
            expirationMonth = true;
            errorMessage.expirationMonth = 'This field is required';
        }
        if (isEmptyOrSpaces(paymentData.data.expirationYear)) {
            expirationYear = true;
            errorMessage.expirationYear = 'This field is required';
        }
        if (creditCardNum || cvv || expirationMonth || expirationYear || nameOnAccount || amount) {
            isValidData = false;
        }
        setpaymentData(Object.assign(Object.assign({}, paymentData), { error: {
                amount,
                creditCardNum,
                cvv,
                expirationMonth,
                expirationYear,
                nameOnAccount,
                country,
                address,
                city,
                state,
                postCode,
            }, errorMessage }));
        return isValidData;
    };
    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        let isError = false;
        if (event.target.required) {
            isError = isEmptyOrSpaces(value) ? true : false;
        }
        setpaymentData(Object.assign(Object.assign({}, paymentData), { data: Object.assign(Object.assign({}, paymentData.data), { [name]: value }), error: Object.assign(Object.assign({}, paymentData.error), { [name]: isError }), errorMessage: Object.assign(Object.assign({}, paymentData.errorMessage), { [name]: isError ? 'This field is required' : '' }) }));
    };
    const handleCountryChange = (event, value, country) => {
        const name = country;
        const studentCountry = (value === null || value === void 0 ? void 0 : value.label) || '';
        setpaymentData((prevPaymentData) => (Object.assign(Object.assign({}, prevPaymentData), { data: Object.assign(Object.assign({}, prevPaymentData.data), { [name]: studentCountry }), error: Object.assign(Object.assign({}, prevPaymentData.error), { [name]: false }), errorMessage: Object.assign(Object.assign({}, prevPaymentData.errorMessage), { [name]: '' }) })));
    };
    const handleDrpDownChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setpaymentData((prevUserData) => (Object.assign(Object.assign({}, prevUserData), { data: Object.assign(Object.assign({}, prevUserData.data), { [name]: value }), error: Object.assign(Object.assign({}, prevUserData.error), { [name]: false }), errorMessage: Object.assign(Object.assign({}, prevUserData.errorMessage), { [name]: '' }) })));
    };
    const handleChangeNumber = (event, type) => {
        const name = event.target.name;
        let only_number = event.target.value.replace(/[^0-9]/g, '');
        let final_number;
        let isError = false;
        let isPhoneNum = false;
        if (name === 'cvv') {
            only_number = only_number.length > 4 ? only_number.substring(0, 4) : only_number;
            final_number = only_number;
        }
        else if (name === 'creditCardNum') {
            only_number = only_number.length > 20 ? only_number.substring(0, 20) : only_number;
            final_number = only_number;
        }
        else if (name === 'amount') {
            final_number = event.target.value.replace(/[^0-9.]|(?<=\..*)\./g, '');
        }
        else {
            final_number = only_number;
        }
        if (event.target.required && isEmptyOrSpaces(final_number)) {
            isError = isEmptyOrSpaces(final_number) ? true : false;
        }
        setpaymentData(Object.assign(Object.assign({}, paymentData), { data: Object.assign(Object.assign({}, paymentData.data), { [name]: final_number }), error: Object.assign(Object.assign({}, paymentData.error), { [name]: isError }), errorMessage: Object.assign(Object.assign({}, paymentData.errorMessage), { [name]: isError ? (isPhoneNum ? 'Invalid Phone Number' : 'This field is required') : '' }) }));
    };
    // useEffect(() => {
    //   if (paymentData) {
    //     setpaymentData(prevData => ({
    //       ...prevData,
    //       data: {
    //         ...prevData.data,
    //         nameOnAccount: paymentData?.data.nameOnAccount || '',
    //         // Update other fields as needed
    //       }
    //     }));
    //   }
    // }, [paymentData]);
    (0, react_1.useEffect)(() => {
        if (transactionId) {
            getCardDetails(transactionId);
        }
        setExpMonthAndYear();
        fetchCountryData();
    }, []);
    const EditPaymentDetails = async (extendMonth = false) => {
        var isValid = validateAll();
        console.log('isValid', isValid);
        if (isValid) {
            let paymentDetails = {
                transactionId: transactionId,
                userId: paymentData.data.userID,
                courseId: paymentData.data.courseId,
                creditCardType: paymentData.data.creditCardType,
                creditCardNum: paymentData.data.creditCardNum,
                amount: paymentData.data.amount,
                nameOnAccount: paymentData.data.nameOnAccount,
                address: paymentData.data.address,
                city: paymentData.data.city,
                state: paymentData.data.state,
                postCode: paymentData.data.postCode,
                country: paymentData.data.country,
            };
            let endDate = new Date(subscribed.endDate);
            if (extendMonth) {
                endDate.setMonth(endDate.getMonth() + 1);
            }
            let subscribedDesmos = {
                planId: subscribed.planId,
                period: subscribed.period,
                startDate: subscribed.startDate,
                endDate: extendMonth ? endDate : subscribed.endDate,
                ongoing: subscribed.ongoing,
                isCancelled: subscribed.isCancelled,
                isAutoRenewal: subscription.isAutoRenewal,
                transactionId: transactionId,
                cvv: paymentData.data.cvv,
                expirationDate: paymentData.data.expirationMonth && paymentData.data.expirationYear ? paymentData.data.expirationMonth.concat('', paymentData.data.expirationYear) : '',
                name: subscribed.name,
                amountSummary: subscribed.amountSummary,
            };
            try {
                const paymentResponse = await (0, shared_1.callApi)(`payment/${transactionId}`, 'PUT', paymentDetails);
                const userResponse = await (0, shared_1.callApi)(`registration/${userId}`, 'PUT', { subscribedDesmos });
                if (!paymentResponse.ok) {
                    throw new Error(`HTTP error in payment update! status: ${paymentResponse.status}`);
                }
                if (!userResponse.ok) {
                    throw new Error(`HTTP error in user update! status: ${userResponse.status}`);
                }
                const paymentData = await paymentResponse.json();
                const userData = await userResponse.json();
                console.log('Payment update response:', paymentData);
                console.log('User update response:', userData);
                handleSnackBarOpen();
                onClose();
            }
            catch (error) {
                console.error('Error:', error);
            }
        }
    };
    // EditPaymentDetails()
    return ((0, jsx_runtime_1.jsxs)(material_1.Dialog, Object.assign({ open: open, onClose: onClose, maxWidth: "sm", fullWidth: true }, { children: [(0, jsx_runtime_1.jsxs)(material_1.DialogTitle, { children: ["Edit payment details", (0, jsx_runtime_1.jsx)(material_1.IconButton, Object.assign({ "aria-label": "close", onClick: onClose, sx: { position: "absolute", right: 8, top: 8 } }, { children: (0, jsx_runtime_1.jsx)(Close_1.default, {}) }))] }), (0, jsx_runtime_1.jsxs)(material_1.DialogContent, { children: [(subscription.IsAutoRenewal && subscription.NumberOfDays == 30) && ((0, jsx_runtime_1.jsx)(material_1.Typography, Object.assign({ variant: "body2", color: "text.secondary", gutterBottom: true }, { children: "We automatically bill on the 1st of each month." }))), (0, jsx_runtime_1.jsx)(material_1.Card, Object.assign({ variant: "outlined", sx: { mb: 3, bgcolor: "primary.50" } }, { children: (0, jsx_runtime_1.jsxs)(material_1.CardContent, Object.assign({ sx: { display: "flex", alignItems: "center" } }, { children: [(0, jsx_runtime_1.jsx)(Layers_1.default, { sx: { mr: 2, color: "primary.main" } }), (0, jsx_runtime_1.jsxs)(material_1.Box, Object.assign({ flexGrow: 1 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, Object.assign({ variant: "subtitle1" }, { children: subscription === null || subscription === void 0 ? void 0 : subscription.AmountSummary })), (0, jsx_runtime_1.jsxs)(material_1.Typography, Object.assign({ variant: "body2", color: "text.secondary" }, { children: [subscription === null || subscription === void 0 ? void 0 : subscription.Period, " ", subscription === null || subscription === void 0 ? void 0 : subscription.Description] }))] })), (0, jsx_runtime_1.jsxs)(material_1.Typography, Object.assign({ variant: "h6" }, { children: ["$", subscription === null || subscription === void 0 ? void 0 : subscription.Amount] }))] })) })), (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, margin: "normal", 
                                // defaultValue={paymentData?.nameOnAccount}
                                label: 'Name On Account', required: true, name: 'nameOnAccount', type: 'text', error: paymentData.error.nameOnAccount, helperText: (_a = paymentData.errorMessage) === null || _a === void 0 ? void 0 : _a.nameOnAccount, value: paymentData.data.nameOnAccount, onChange: handleChange }), (0, jsx_runtime_1.jsx)(material_1.TextField, { label: "Address", fullWidth: true, margin: "normal", name: 'address', type: 'text', 
                                // defaultValue={paymentData?.address}
                                value: paymentData.data.address, onChange: handleChange }), (0, jsx_runtime_1.jsx)(material_1.TextField, { label: "City", margin: "normal", name: 'city', 
                                // defaultValue={paymentDetails?.city}/
                                value: paymentData.data.city, onChange: handleChange, sx: { width: "48%", mr: "4%" } }), (0, jsx_runtime_1.jsx)(material_1.TextField, { label: "State", margin: "normal", name: 'state', 
                                // defaultValue={paymentDetails?.state}
                                value: paymentData.data.state, onChange: handleChange, sx: { width: "48%" } }), (0, jsx_runtime_1.jsxs)(material_1.Box, Object.assign({ sx: { display: 'flex', flexWrap: 'wrap', gap: '4%', alignItems: 'center' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.TextField, { margin: "normal", 
                                        // defaultValue={paymentDetails?.postCode}
                                        sx: { width: "48%", mt: "1%" }, label: 'Postal Code', name: 'postCode', type: 'text', value: paymentData.data.postCode, onChange: (event, ...rest) => {
                                            event.preventDefault();
                                            handleChangeNumber(event, 'none');
                                        } }), (0, jsx_runtime_1.jsx)(material_1.Autocomplete, { id: 'paymentCountry', sx: { width: "48%" }, value: paymentData.data.country, options: countryData, onChange: (event, value) => {
                                            handleCountryChange(event, value, 'country');
                                        }, autoHighlight: true, renderInput: (params) => ((0, jsx_runtime_1.jsx)(material_1.TextField, Object.assign({}, params, { label: 'Country', sx: {
                                                '& .MuiFormLabel-asterisk': {
                                                    color: 'red',
                                                },
                                            } }))), renderOption: (props, option) => ((0, jsx_runtime_1.jsxs)(material_1.Box, Object.assign({ component: 'li', sx: { '& > img': { mr: 2, flexShrink: 0 } } }, props, { children: [(0, jsx_runtime_1.jsx)("img", { loading: 'lazy', width: '20', srcSet: option.flag, src: option.flag, alt: 'flag' }), option.label] }))) })] })), (0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, margin: "normal", label: 'Credit Card No', name: 'creditCardNum', type: 'text', required: true, error: paymentData.error.creditCardNum, helperText: paymentData.errorMessage.creditCardNum, value: paymentData.data.creditCardNum, onChange: (event, ...rest) => {
                                    event.preventDefault();
                                    handleChangeNumber(event, 'none');
                                } }), (0, jsx_runtime_1.jsxs)(material_1.FormControl, Object.assign({ required: true, error: paymentData.error.expirationMonth, sx: { width: "30%", mr: "3%" } }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, Object.assign({ id: "expiration-month-label" }, { children: "Month" })), (0, jsx_runtime_1.jsx)(material_1.Select, Object.assign({ labelId: "expiration-month-label", name: "expirationMonth", required: true, value: paymentData.data.expirationMonth, onChange: handleDrpDownChange }, { children: (expMonths || []).map((mnth, idx) => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, Object.assign({ value: mnth.id }, { children: `${mnth.name} (${idx + 1})` }), idx))) }))] })), (0, jsx_runtime_1.jsxs)(material_1.FormControl, Object.assign({ required: true, error: paymentData.error.expirationYear, sx: { width: "30%", mr: "3%" } }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, Object.assign({ id: "expiration-year-label" }, { children: "Year" })), (0, jsx_runtime_1.jsx)(material_1.Select, Object.assign({ labelId: "expiration-year-label", name: "expirationYear", required: true, value: paymentData.data.expirationYear, onChange: handleDrpDownChange }, { children: (expYears || []).map((year, idx) => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, Object.assign({ value: year.id }, { children: year.name }), idx))) }))] })), (0, jsx_runtime_1.jsx)(material_1.TextField, { label: "CVV", type: "password", sx: { width: "30%" }, name: 'cvv', required: true, error: paymentData.error.cvv, helperText: paymentData.errorMessage.cvv, value: paymentData.data.cvv, onChange: (event, ...rest) => {
                                    event.preventDefault();
                                    handleChangeNumber(event, 'none');
                                } })] })] }), (0, jsx_runtime_1.jsxs)(material_1.DialogActions, Object.assign({ sx: { justifyContent: "space-between", px: 3, pb: 2 } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({ onClick: onClose, sx: { mr: 1 } }, { children: "Cancel" })), (0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({ variant: "contained", disabled: !((_b = paymentData === null || paymentData === void 0 ? void 0 : paymentData.data) === null || _b === void 0 ? void 0 : _b.nameOnAccount), onClick: () => EditPaymentDetails(false) }, { children: "Save changes" }))] })), (0, jsx_runtime_1.jsxs)(material_1.Dialog, Object.assign({ open: ConfirmDialogOpen, onClose: handleClose, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" }, { children: [(0, jsx_runtime_1.jsx)(material_1.DialogTitle, Object.assign({ id: "alert-dialog-title" }, { children: "Are you sure you want to extend your plan for one month?" })), (0, jsx_runtime_1.jsxs)(material_1.DialogActions, { children: [(0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({ onClick: handleClose }, { children: "No" })), (0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({ onClick: () => EditPaymentDetails(true), autoFocus: true }, { children: "Yes" }))] })] }))] })));
};
exports.default = PaymentSubscriptions;
